import { render, staticRenderFns } from "./DashboardBar.vue?vue&type=template&id=a7bb94f2"
import script from "./DashboardBar.vue?vue&type=script&lang=js"
export * from "./DashboardBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports